module["exports"] = [
  "#{street_name}, #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/street_address.js
// module id = 1298
// module chunks = 0